import { ViewModel,View } from "binder"
import { DataModelBuilderViewModel, DataModelClass, Property } from "../dataModelBuilder-viewModel";
import  { PropertyBodyCodeEditorView } from "./propertyBodyCodeEditor-view"

export class PropertyBodyCodeEditorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new PropertyBodyCodeEditorView();
    }
    public getTypeId(): string {
        return "VM-FA6BC57F-DD0B-4B98-AC09-9FAA6D8BF760"
    }

    public set model(v: DataModelBuilderViewModel) { this._model = v; } public get model(): DataModelBuilderViewModel { return this._model;} private _model: DataModelBuilderViewModel;
    public set currentClass(v: DataModelClass) { this._currentClass = v; } public get currentClass(): DataModelClass { return this._currentClass;} private _currentClass: DataModelClass;
    public set currentProperty(v: Property) { this._currentProperty = v; } public get currentProperty(): Property { return this._currentProperty;} private _currentProperty: Property;
    
    closePopup(result?: any) {
    }
    confirm(preCode:string,postCode:string){
        this.closePopup({
            pre:preCode,
            post:postCode
        });
    }
    close(){
        this.closePopup();
    }
}
